import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import RouterTab from './RouterTab';

const RouterTabs = ({ children, className, disabled, location, onClickTabItem }) => (
  <div className={classNames(className, 'router-tabs')}>
    <div className="router-tab-items">
      {children.map((child) => {
        const { path } = child.props;

        return (
          <RouterTab
            disabled={disabled}
            isActive={location.pathname.includes(`/${path}`)}
            key={path}
            onTabClick={onClickTabItem}
            path={path}
          >
            {child}
          </RouterTab>
        );
      })}
    </div>
  </div>
);

RouterTabs.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  onClickTabItem: PropTypes.func.isRequired,
};

RouterTabs.defaultProps = {
  className: undefined,
  disabled: false,
};

export default RouterTabs;
